import type { TranscriptTurn } from "@memorang/types/src/session/new-session";

import type { TranscriptMessage } from "../types";

/**
 * Flattens the live conversation into the persisted transcript shape. Roles are
 * generic (mentor -> user, any avatar persona -> avatar); audioUrl rides only on
 * avatar turns that have an uploaded URL.
 */
export const buildSimulationTranscript = (
	messages: TranscriptMessage[],
): TranscriptTurn[] =>
	messages.map((message) => {
		if (message.role === "mentor") {
			return { role: "user", text: message.text };
		}
		return {
			role: "avatar",
			text: message.text,
			...(message.audioUrl ? { audioUrl: message.audioUrl } : {}),
		};
	});
